import component from './userTask';
import taskConfig from '../task';

export default {
  ...taskConfig,
  component,
};
